import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';

// style
import { colors } from '../../style';

export const tableRowVariants = {
  gray100: css`
    background: ${colors.gray100};
  `,
  'gray100-border-bottom': css`
    background: ${colors.gray100};
    border-bottom: 1px solid ${colors.gray300};
  `,
  'border-bottom-gray300': css`
    &:not(:last-of-type) {
      border-bottom: 1px solid ${colors.gray300};
    }

    thead & {
      border-bottom: 1px solid ${colors.gray300};
    }
  `,
  'border-bottom-gray300-all': css`
    border-bottom: 1px solid ${colors.gray300};
  `,
  default: css``,
};

export interface TableRowProps {
  variant?: keyof typeof tableRowVariants;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  height?: number;
  minHeight?: number;
  disabled?: boolean;
  'data-testid'?: string;
  id?: string;
  ref?: React.Ref<HTMLTableRowElement>;
  onClick?: (event: React.MouseEvent<HTMLTableRowElement>) => void;
}

export const TableRow = styled.tr
  .withConfig({ shouldForwardProp: prop => prop !== 'disabled' })
  .attrs<TableRowProps>(props => ({
    className: classNames(props.className, { disabled: props.disabled }),
  }))<TableRowProps>`
  border: none;
  ${props => tableRowVariants[props.variant || 'default']};
  min-height: ${props => (typeof props.minHeight === 'number' ? `${props.minHeight}px` : undefined)};
  height: ${props => (typeof props.height === 'number' ? `${props.height}px` : undefined)};
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`;

export default TableRow;
